/*
 * @Author: zhangyugegeliuchen@didichuxing.com 
 * @Date: 2019-01-08 18:16:03
 * @Last Modified by: zhangyugegeliuchen@didichuxing.com
 * @Last Modified time: 2019-01-08 18:16:03
 * @Description:  简略的页面生成器 可以动态生成你传入的页面
 */
<script>
import landingPage from '../landingPage'
import NoActivity from '../noActivity'
export default {
  name: 'PageCreater',
  components: {
    landingPage,
    NoActivity
  },
  props: {
    // 传入的页面
    name: Object
  },
  methods: {
    createGenElement (createElement, name) {
      // 可扩展
      return [
        createElement(
          name,
          {}
        )]
    }
  },
  render (h) {
    return h(
      'div',
      {
        class: 'page-creater'
      },
      this.createGenElement(
        h,
        this.name
      )
    )
  }
}
</script>

<style lang="scss" scoped>
.cropper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: white;
}
</style>
